import { render, staticRenderFns } from "./FloorFigureList.vue?vue&type=template&id=33f874f7&"
import script from "./FloorFigureList.vue?vue&type=script&lang=js&"
export * from "./FloorFigureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports